export const EKybStatus = {
  Approved: "Approved",
  Pending: "Pending",
  NeedsReview: "Needs review",
  NotStarted: "Not started",
} as const;

export type EKybStatus = (typeof EKybStatus)[keyof typeof EKybStatus];
